import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import PersonaSelect from "../components/PersonaSelect";
import { api } from "../lib/api";

const PRIO = { alta: "text-red-400", media: "text-amber-400", baixa: "text-neutral-400" };

export default function Zonas() {
  const [pid, setPid] = useState("");
  const [zones, setZones] = useState([]);
  const [busy, setBusy] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!pid) { setZones([]); return; }
    api.listZones(pid).then(setZones).catch((e) => setErr(String(e.message)));
  }, [pid]);

  const gen = async () => {
    setBusy("gen"); setErr("");
    try { setZones(await api.generateZones(pid)); }
    catch (e) { setErr(String(e.message)); } finally { setBusy(""); }
  };
  const camp = async (zid) => {
    setBusy(zid); setErr("");
    try { await api.generateCampaign(zid); alert("Campanha criada (ver aba Campanhas)"); }
    catch (e) { setErr(String(e.message)); } finally { setBusy(""); }
  };

  return (
    <Layout>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Zonas de Intenção</h1>
          <p className="text-neutral-400 text-sm mt-1">Clusters geográfico-comportamentais com score de oportunidade e recomendação de campanha.</p>
        </div>
        <PersonaSelect value={pid} onChange={setPid} />
      </div>
      {err && <div className="mt-4 rounded-md bg-red-600/15 text-red-400 px-4 py-2 text-sm">{err}</div>}
      {pid && (
        <button onClick={gen} disabled={busy === "gen"}
          className="mt-4 rounded-md bg-red-600 hover:bg-red-500 px-4 py-2 text-sm font-medium disabled:opacity-50">
          {busy === "gen" ? "Clusterizando…" : "Gerar zonas"}
        </button>
      )}
      <div className="mt-6 space-y-3">
        {zones.map((z) => (
          <div key={z.id} className="rounded-lg border border-neutral-800 bg-neutral-900/50 p-4">
            <div className="flex justify-between items-start">
              <span className="font-medium">{z.name}</span>
              <span className="text-xs">
                <span className="text-emerald-400">oportunidade {z.opportunity_score}</span>
                <span className={"ml-3 " + (PRIO[z.priority] || "")}>{z.priority}</span>
              </span>
            </div>
            <div className="text-xs text-neutral-500 mt-1">{z.places?.length || 0} locais · centro {z.center_latitude?.toFixed?.(4)}, {z.center_longitude?.toFixed?.(4)}</div>
            {z.behavioral_profile && <div className="text-xs text-neutral-400 mt-2">{z.behavioral_profile}</div>}
            {z.campaign_recommendation && <div className="text-xs text-neutral-300 mt-1 italic">→ {z.campaign_recommendation}</div>}
            <button onClick={() => camp(z.id)} disabled={busy === z.id}
              className="mt-3 text-xs text-red-400 hover:text-red-300 disabled:opacity-50">
              {busy === z.id ? "Gerando campanha…" : "Ativar campanha →"}
            </button>
          </div>
        ))}
        {pid && !zones.length && <div className="text-neutral-500 text-sm">Sem zonas. Gere os locais primeiro, depois clique "Gerar zonas".</div>}
      </div>
    </Layout>
  );
}
